<template>
  <div class="box-container">
    <a-modal v-model="modalVisible" style="margin-top: 10px;" width="50%">
      <template slot="footer">
        <a-button @click="modalVisible=false">取消</a-button>
        <a-button type="primary" @click="confirm">确认</a-button>
      </template>
      <div class="box-container-inner">
        <div class="table-header">
          <h3 class="table-title">选择电梯品牌</h3>
        </div>
      </div>
      <div class="box-container-inner">
        <div class="simple-query">
          <a-form-model ref="queryForm" :model="queryParams" layout="inline" class="query-form" style="text-align: center">
            <a-form-model-item label="电梯品牌" prop="value" >
              <a-input v-model.trim="queryParams.value" placeholder="请输入"></a-input>
            </a-form-model-item>
            <a-form-model-item>
              <a-button type="primary" class="after-btn" @click="getTableData">查询</a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
<!--        <div class="query-btns" style="text-align: center">-->
<!--          <a-button type="primary" class="after-btn" @click="initBrandidOptions">查询</a-button>-->
<!--        </div>-->
      </div>
      <div class="box-container" style="margin-top: 10px;">
        <div class="box-container-inner">
          <a-table :row-selection="{onChange: rowSelectChange,type : 'radio'}" :columns="tableColumns" :data-source="tableData" row-key="liftpropertyid" :loading="tableLoading" :row-class-name="(record, index) => (index%2==0?'table-row-even':'table-row-single')" style="margin-top: 20px;" :pagination="false">
          </a-table>
          <a-pagination v-model="currentPage" :total="pagination.total" :page-size="pagination.pageSize" show-size-changer @change="pageChange" :show-total="(total, range) => `共${total}条`" @showSizeChange="onShowSizeChange" style="margin-top: 20px; text-align: right;">
            <template slot="buildOptionText" slot-scope="props">
              <span>{{ props.value }}条/页</span>
            </template>
          </a-pagination>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import areaselect from "@/mixins/areaselect";
import deptselect from "@/mixins/deptselect";
import pagination from "@/mixins/pagination";
import {getLiftListByCondition} from "A/jcgn";

export default {
  mixins: [areaselect, deptselect, pagination],
  name: "brandSelect",
  props: {
    visible: {
      default: false
    },
  },
  data(){
    return{
      queryParams: {
        value:'',
      },
      modalVisible: false,
      tableData: [],
      tableLoading: false,
      tableColumns: [
        {
          title: '电梯品牌',
          dataIndex: 'value',
          key: 'value',
          ellipsis: true,
          width:100
        },
      ],
    }
  },
  watch: {
    visible(val) {
      if(val) {
        this.modalVisible = true;
        this.getTableData();
      }
    },
    modalVisible(val) {
      if(!val) {
        this.$emit('update:visible', false);
      }
    },
  },
  created() {
    this.modalVisible = this.visible;
  },
  methods:{
    getTableData() {
      let params = {
        value:this.queryParams.value,
        liftpropertytype: '3',
        pageno: this.currentPage,
        pagesize: this.pagination.pageSize
      }
      getLiftListByCondition(params).then(res => {
        if(res && res.returncode == '0') {
          this.tableData = res.item;
          this.pagination.total = res.count;
        }
      })
    },
    rowSelectChange(selectedRowKeys, selectedRows) {
      this.batchliftids = selectedRowKeys.join('|');
      this.batchrow=selectedRows
    },
    confirm(){
      this.$emit('upDate',this.batchrow)
      this.modalVisible=false;
    },
  },
}
</script>

<style scoped>

</style>